export default function TestimonialSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto px-6 md:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 lg:w-3/5">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-2 h-2 rounded-full bg-accent-500"></span>
              <span className="text-xs font-semibold text-foreground-500 font-sans uppercase tracking-wider">Verified User Review</span>
            </div>
            <blockquote className="font-heading text-2xl md:text-3xl lg:text-4xl text-foreground-950 leading-snug font-medium italic">
              &ldquo;Mulebuy Spreadsheet completely changed how I organize sourcing data. The structured format saves hours every week. Truly the best SEO hub for buyers.&rdquo;
            </blockquote>
            <div className="mt-6 flex items-center gap-3">
              <div>
                <p className="font-sans text-sm font-semibold text-foreground-950">James Mitchell</p>
                <div className="flex items-center gap-1.5 mt-0.5">
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  <span className="ml-1 text-xs text-foreground-400 font-sans">TrustScore 4.9</span>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1 lg:w-2/5">
            <div className="relative w-full max-w-sm mx-auto lg:max-w-none" style={{ aspectRatio: '3/4' }}>
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20lifestyle%20portrait%20of%20a%20confident%20professional%20in%20a%20cream%20linen%20shirt%20sitting%20at%20a%20wooden%20desk%20with%20a%20laptop%20and%20notebook%2C%20natural%20window%20light%20from%20the%20right%20creating%20soft%20shadows%2C%20relaxed%20and%20genuine%20expression%20with%20slight%20smile%2C%20editorial%20business%20portrait%20with%20warm%20earthy%20tones%20and%20cream%20background%2C%20approachable%20and%20trustworthy%20aesthetic%20with%20professional%20yet%20friendly%20atmosphere&width=600&height=800&seq=testimonial-v3-a4c2&orientation=portrait"
                alt="Verified Mulebuy Spreadsheet User"
                className="w-full h-full object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}